var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShangChuan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E0A\u4F201") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.2785849%",
    y1: "-15.6234215%",
    x2: "50.2785849%",
    y2: "83.8194086%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19A3F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2077FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18\\u62A5\\u540D-\\u6807\\u51C6\\u8BFE\\u7A0B",
    transform: "translate(-870, -632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E0A\\u4F201",
    transform: "translate(870, 632)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#EEF5FF",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "wenjianjia",
    transform: "translate(16, 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,33 C56,34.1045695 56.8954305,35 58,35 C59.1045695,35 60,34.1045695 60,33 C60,31.8954305 59.1045695,31 58,31 C56.8954305,31 56,31.8954305 56,33 L56,33 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#1D88FB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8439906,39.8496567 C56.6521594,39.8496567 55.6879813,40.8211059 55.6879813,42.0151789 L55.6879813,47.4593422 C55.6879813,49.8407421 53.7663207,51.7768944 51.4027452,51.7768944 L8.59725477,51.7768944 C6.23367928,51.7768944 4.31201875,49.8407421 4.31201875,47.4593422 L4.31201875,8.62161185 C4.31201875,6.24021202 6.23367928,4.30405975 8.59725477,4.30405975 L23.4951456,4.30405975 L29.0324741,13.9713288 C29.474389,14.7403927 30.3180449,15.1316709 31.1416137,15.0372244 L51.3960495,15.0372244 C53.759625,15.0372244 55.6812856,16.9733767 55.6812856,19.3547765 L55.6812856,24.7517167 C55.6812856,25.9457897 56.6454637,26.9172389 57.8372949,26.9172389 C59.0291262,26.9172389 59.9933043,25.9457897 59.9933043,24.7517167 C59.9933043,24.6977473 59.9933043,24.6437779 59.9866086,24.5898085 L59.9866086,19.3615227 C59.9866086,15.637634 57.6498159,12.4669317 54.368932,11.2526202 L54.368932,11.1851584 C54.368932,6.58426696 50.6327419,2.81990122 46.0662872,2.81990122 L27.5929026,2.81990122 L26.6019417,1.0861342 C26.1064613,0.215877605 25.3967191,-0.00674617516 24.7740208,0.00674617516 L24.7673251,0 L8.57047205,0 C3.83662538,0 0,3.86555837 0,8.6351042 L0,47.3648958 C0,52.1344416 3.83662538,56 8.57047205,56 L51.4228323,56 C56.1566789,56 59.9933043,52.1344416 59.9933043,47.3648958 L59.9933043,42.1770871 C60,42.1231177 60,42.0691483 60,42.0151789 C60,40.8211059 59.0358219,39.8496567 57.8439906,39.8496567 Z M45.7315032,7.12396097 C47.8473385,7.12396097 49.6149983,8.68907361 49.9564781,10.7264185 L32.1258788,10.7264185 L30.063609,7.12396097 L45.7315032,7.12396097 L45.7315032,7.12396097 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShangChuan);
export default __webpack_public_path__ + "static/media/shangChuan.360783efc160aaed94150430395eb817.svg";
export { ForwardRef as ReactComponent };